import AbsComponent from "../AbsComponent";
import DetailSkill from "./DetailSkill";
import DetailItem from "./DetailItem";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from '../../common/bodyScrollLock.es6';

class Detail extends AbsComponent{
    constructor(_store={}, _router={}, _el=''){
        super('class Detail', _store, _router, _el);

        let watchLoadStatus = this.watch(this.store.getState, 'loadStatusDetail', this.isEqual);
        this.store.subscribe( watchLoadStatus( (newVal, oldVal, path) => this.loadStatus(newVal, oldVal, path, newVal)));

        let watchDetail = this.watch(this.store.getState, 'detail', this.isEqual);
        this.store.subscribe( watchDetail( (newVal, oldVal, path) => this.render(newVal, oldVal, path) ) );

        let watchdetailIsShow = this.watch(this.store.getState, 'detailIsShow', this.isEqual);
        this.store.subscribe( watchdetailIsShow( (_newVal, _oldVal, _path) => {
            $(this.el + ' .gd-search-detail-layer-wrap').toggleClass('is-show', _newVal);
            if(_device != 'pc' && _device != 'launcher' && _newVal){
                disableBodyScroll($('.gd-search-detail-layer-inner')[0]);
            }else{
                enableBodyScroll($('.gd-search-detail-layer-inner')[0]);
            }
        } ) );

        //----------------------------------------------------------------------------------------------------------------------------------------
        //----------------------------------------------------------------------------------------------------------------------------------------
        this.itemTempl = new DetailItem(this.store.getState().config.tab);
        this.skillTempl = new DetailSkill(this.store.getState().config.tab);

        let watchSkillId = this.watch(this.store.getState, 'skillId', this.isEqual);
        this.store.subscribe( watchSkillId( (_newVal, _oldVal, _path) => {
            this.store.dispatch( this.actions.setSkillLevel(''));
            this.store.dispatch( this.actions.loadDetail('skill') ) 
        }));

        let watchSkillLevel = this.watch(this.store.getState, 'skillLevel', this.isEqual);
        this.store.subscribe( watchSkillLevel( (_newVal, _oldVal, _path) => {
            this.store.dispatch( this.actions.loadDetail('skill', this.store.getState().skillLevel) ) 
        }));

        let watchItemId = this.watch(this.store.getState, 'itemId', this.isEqual);
        this.store.subscribe( watchItemId( (_newVal, _oldVal, _path) => this.store.dispatch( this.actions.loadDetail('item') )));

        if (this.store.getState().config.db == 'skill') {
            if ( this.store.getState().skillId ) {
                this.store.dispatch( this.actions.loadDetail('skill', this.store.getState().skillLevel) );
            } else if ( this.store.getState().itemId ) {
                this.store.dispatch( this.actions.loadDetail('item') );
            }
        }
        
        if (this.store.getState().config.db == 'item') {
            if ( this.store.getState().itemId ) {
                this.store.dispatch( this.actions.loadDetail('item') );
            } else if ( this.store.getState().skillId ) {
                this.store.dispatch( this.actions.loadDetail('skill', this.store.getState().skillLevel)  );
            }
        }
        //----------------------------------------------------------------------------------------------------------------------------------------
        //----------------------------------------------------------------------------------------------------------------------------------------
    }

    addEvents(){
        $(this.el + ' .gd-detail-imginfo-list li').on('click', (e)=>{
            let it = $(e.currentTarget);
            this.store.dispatch( this.actions.addRecentList({id: it.data('id'), name: it.data('name'), image: it.data('image'), db: 'itemid'}));
            this.store.dispatch( this.actions.setUserselect(true));
            this.store.dispatch( this.actions.setDetailIsshow(true));
            this.router.goSingleParam( 'itemid', it.data('id') );
            return false;
        });
        
        $(this.el + ' .gd-search-detail-layer-wrap .gd-btn-close-layer').on('click', (e)=>{
            this.store.dispatch( this.actions.setDetailIsshow(false));
            return false;
        });
        
        $(this.el + ' .gd-search-detail-content .gd-detail-level-wrap .gd-detail-select').on('change', (e)=>{
            this.store.dispatch( this.actions.setSkillLevel(e.currentTarget.value));
        });
        
        $(this.el + ' .gd-search-detail-content .gd-detail-textinfo-list li.needlist button').on('click', (e)=>{
            let it = $(e.currentTarget);
            this.store.dispatch( this.actions.addRecentList({id: it.data('id'), name: it.data('name'), image: it.data('image'), db: 'itemid'}));
            this.store.dispatch( this.actions.setUserselect(true));
            this.store.dispatch( this.actions.setDetailIsshow(true));
            this.router.goSingleParam( 'itemid', it.data('id') );
            return false;
        });

        window.addEventListener("orientationchange", () => {
            this.store.dispatch( this.actions.setDetailIsshow(false));
        });
    }

    render(_newVal, _oldVal, _path){
        let templ = this.itemTempl;
        let nowDB = 'itemid';
        let nowID = this.store.getState().itemId;

        if (this.store.getState().skillId) {
            templ = this.skillTempl;
            nowDB = 'skillid';
            nowID = this.store.getState().skillId;
        }
        
        $(this.el + ' .gd-search-detail-layer-wrap').toggleClass('is-no-result', !_newVal.name);
        if (_newVal.errMessage) {
            $('.gd-no-result-detail-wrap .gd-no-result-sub-text').html('죄송합니다. 일시적인 오류가 발생하였습니다.<br>잠시 후 다시 이용해 주세요.');
            this.store.dispatch( this.actions.removeRecentList({id: parseInt(nowID), db: nowDB}));
            return false;
        }
        if (!_newVal.name) {
            $('.gd-no-result-detail-wrap .gd-no-result-sub-text').html('상세 정보가 제공되지 않는 데이터입니다.<br>다른 데이터를 선택해 주세요.');
            this.store.dispatch( this.actions.removeRecentList({id: parseInt(nowID), db: nowDB}));
            return false;
        }
        $('.gd-search-detail-layer-inner').html(templ.getTempl(_newVal));
        this.addEvents();
    }

    loadStatus(_newVal, _oldVal, _path){
        $('.gd-layer-top .gd-loading-circle').toggle(_newVal==='isLoading');
    }

} // end of class
export default Detail;